import React from 'react';

import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

import QRCode from 'components/qrcode';
import { useFormatLoyaltyBarcode } from 'components/th-scan-and-pay/hooks/use-format-loyalty-barcode';
import { useScanAndPayContext } from 'components/th-scan-and-pay/state/provider';
import { ILoyaltyCard } from 'generated/rbi-graphql';
import { generateCardIdLabel } from 'pages/account/tims-rewards/details';
import { useThRewardsManagementContext } from 'state/th-rewards-management';

import { ContentBlock, HeaderContainer, Heading, SubHeading } from '../../styled';

import { BARCODE_OPTIONS } from './constants';
import { QRText } from './qr-text';
import { CardNumber, QRCodeContainer, QRCodeWrapper } from './styled';

interface IScanQRContentProps {
  loading: boolean;
  loadingTier: boolean;
  activeCard: ILoyaltyCard | null;
}

export const ScanQRContent = ({ loading, loadingTier, activeCard }: IScanQRContentProps) => {
  const { formatMessage } = useIntl();
  const barcode = useFormatLoyaltyBarcode();
  const { scanAndPayEnabledForUser } = useScanAndPayContext();
  const {
    loadingStatus: loadingScanAndPayStatus,
    loadingSelectedPaymentMethod: loadingScanAndPayPaymentMethod,
    updatingSelectedPaymentMethod: updatingScanAndPayPaymentMethod,
    updatingStatus: updatingScanAndPayStatus,
  } = useScanAndPayContext();
  const { updatingRewardTier } = useThRewardsManagementContext();
  const isLoading =
    loading ||
    loadingTier ||
    loadingScanAndPayPaymentMethod ||
    loadingScanAndPayStatus ||
    updatingRewardTier ||
    updatingScanAndPayPaymentMethod ||
    updatingScanAndPayStatus;

  return (
    <ContentBlock>
      <>
        <HeaderContainer>
          <Heading>
            {scanAndPayEnabledForUser
              ? formatMessage({ id: 'scanToEarnRewardsAndPay' })
              : formatMessage({ id: 'scanForTimsRewards' })}
          </Heading>
          <SubHeading>
            {scanAndPayEnabledForUser
              ? formatMessage({ id: 'scanToEarnPointsPayAndUseRewards' })
              : formatMessage({ id: 'putThisCodeUnderTheScanner' })}
          </SubHeading>
        </HeaderContainer>
        {isLoading ? (
          <Skeleton width={'180px'} height={'180px'} />
        ) : (
          <>
            <QRCodeWrapper>
              <QRCodeContainer>
                <QRCode barcode={barcode} options={BARCODE_OPTIONS} />
              </QRCodeContainer>
            </QRCodeWrapper>
            <QRText barcode={barcode} />
          </>
        )}
        <SubHeading>{formatMessage({ id: 'yourTimsRewardsNumber' })}</SubHeading>
      </>
      {activeCard && <CardNumber>{generateCardIdLabel(activeCard.cardId)}</CardNumber>}
    </ContentBlock>
  );
};

export default ScanQRContent;
